const jSendStatus = {
	SUCCESS: 'success',
	FAIL: 'fail',
	ERROR: 'error'
};

export default jSendStatus;

export class JSendStatus extends String {
	public static ERROR = jSendStatus.ERROR;
	public static FAIL = jSendStatus.FAIL;
	public static SUCCESS = jSendStatus.SUCCESS;
}

export interface IJSendRuleViolation {
	message: string;
	fields: string[];
}

export interface IJSendEnvelope<T> {
	data?: T;
	status: JSendStatus;
}

export interface IJSendFailEnvelope extends IJSendEnvelope<IJSendRuleViolation[]> {
	data: IJSendRuleViolation[];
	message: string;
}
